<footer>
  <p>&copy; {{ currentYear }} e-cclesia. Todos los derechos reservados.</p>
</footer>
